import { createContext, useContext } from 'react';
import noop from 'lodash/noop';

import api, {
    AddPassengerToTravelFile,
    BodyEditPassengerTravelFile,
    RemovePassengerFromTravelFile,
    ReinstatePassengerToTravelFile
} from '../api';
import { Passenger } from '../types';
import { ModelOptions, QueryContext } from '../../../types';
import { TravelFile } from '../../travelFiles/oldModelTypes';
import { PassengerQueryType } from '../helpers';

interface Context<T> {
    get: (params?: Partial<T>, options?: ModelOptions, updateState?: boolean) => Promise<Array<T>>;
    getOne: (params: Partial<T>, body?: { populateQuery: Array<any> }) => Promise<T>;
    post: (body: Partial<T>, updateState?: boolean, last?: boolean) => Promise<T>;
    put: (body: Partial<T>) => Promise<T>;
    remove?: (id: string) => Promise<string>;
    softDelete: (body: { _id: string }) => Promise<any>;
    data: T[];
    setData: (array: Array<T>) => void;
    selected: T | null;
    setSelected: (object: T) => void;
    error?: T | null | {};
}

interface ExtendedContext extends Context<Passenger> {
    addPassengerToTravelFile: (body: AddPassengerToTravelFile) => Promise<TravelFile>;
    editPassengerTravelFile: (body: BodyEditPassengerTravelFile) => Promise<TravelFile>;
    removePassengerFromTravelFile: (body: RemovePassengerFromTravelFile) => Promise<TravelFile>;
    reinstatePassengerToTravelFile: (body: ReinstatePassengerToTravelFile) => Promise<TravelFile>;
    query: QueryContext<PassengerQueryType, Passenger>;
}

const PassengersContext = createContext<ExtendedContext>({
    get: api.get,
    getOne: api.getOne,
    post: api.post,
    put: api.put,
    remove: api.remove,
    softDelete: api.softDelete,
    data: [],
    setData: noop,
    selected: null,
    setSelected: noop,
    error: null,
    addPassengerToTravelFile: api.addPassengerToTravelFile,
    editPassengerTravelFile: api.editPassengerTravelFile,
    removePassengerFromTravelFile: api.removePassengerFromTravelFile,
    reinstatePassengerToTravelFile: api.reinstatePassengerToTravelFile,
    query: api.query
});
export function useGetPassengersContext() {
    try {
        return useContext(PassengersContext);
    } catch (error) {
        console.error(error);
        throw new Error('not get PassengersContext correctly!');
    }
}
export default PassengersContext;
